import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockBalances } from '@/renderer/services/inventoryStockBalanceService';
import type { InventoryStockBalanceFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockBalances(
  params: InventoryStockBalanceFilterParams,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockBalancesList(params),
    queryFn: async () => {
      const result = await fetchInventoryStockBalances(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock balances',
        );
      }

      return result.data;
    },
    enabled:
      !!params.companyId && !!params.outletId && (options?.enabled ?? true),
    placeholderData: keepPreviousData,
  });
}
